import axios from 'axios';
import { getOrganizationId } from '../organization';
import { ensureAiCreditsForTrigger } from '../aiCreditsGuard';
import { getAiAnalyticsBaseUrl } from '../aiAnalyticsUrl';

export interface AnalysisItem {
    phone_number: string;
    conversation_id: string;
    emotion: string;
    emoji: string;
    confidence: number;
    summary: string;
    score: number;
    conversation_stage: string;
}

export interface BehaviorAnalysisResponse {
    business_account_id: string;
    analyses: AnalysisItem[];
    tags: any[];
    metadata: {
        total_messages: number;
        model: string;
        generation_time_seconds: number;
        input_tokens: number;
        output_tokens: number;
        total_tokens: number;
        total_cost_usd: number;
    };
    total_contacts: number;
    current_page: number;
    page_size: number;
    total_pages: number;
}

const suggestionsClient = axios.create({
    baseURL: getAiAnalyticsBaseUrl('api'),
    headers: {
        'Content-Type': 'application/json'
    }
});

export interface BehaviorAnalysisFilters {
    search?: string;
    status?: string;
    priority?: 'high' | 'medium' | 'low';
    isRequested?: boolean;
    isSteppedIn?: boolean;
}

export interface SuggestionItem {
    reply: string;
    tone: string;
    rationale: string;
}

export interface SuggestedResponsesResponse {
    business_account_id: string;
    phone_number: string;
    suggestions: SuggestionItem[];
    metadata: {
        total_messages: number;
        model: string;
        generation_time_seconds: number;
        input_tokens: number;
        output_tokens: number;
        total_tokens: number;
        total_cost_usd: number;
    };
}

export const suggestionsApi = {
    getBehaviorAnalysis: async (businessAccountId: string, page = 1, limit = 100, filters: BehaviorAnalysisFilters = {}) => {
        await ensureAiCreditsForTrigger({ businessAccountId });
        const organizationId = getOrganizationId();
        return suggestionsClient.post<BehaviorAnalysisResponse>('/suggestion/behavior', {
            business_account_id: businessAccountId,
            ...(organizationId ? { organization_id: organizationId } : {}),
            limit: limit,
            page: page,
            page_size: limit, // mapping limit to page_size as well to be safe or just standard
            search: filters.search,
            status: filters.status,
            priority: filters.priority,
            isRequested: filters.isRequested, // Changed from is_requested to match curl
            is_stepped_in: filters.isSteppedIn
        });
    },
};
